module.exports = {
    "longPressMessage": `Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu`
};


//# sourceMappingURL=pt-BR.main.js.map
